/* Odyssey - defer video loading. Aug 20 2026.

   WHY: a single mobile product page view was pulling 9.49 MB, of which
   9.34 MB (98%) was video - every clip on the page downloading before the
   visitor had scrolled anywhere near it. The clips play fine; they were
   simply all loading at once, which is expensive on paid mobile traffic
   and leaves black rectangles on screen while they buffer.

   WHAT: a clip loads once it is within one viewport of being seen, and not
   before. Anything already on screen at load is left alone, so nothing that
   should show a frame turns into a black box. Autoplaying clips still
   autoplay - they just start when they are actually near the screen.

   Safe to remove: deleting this file only restores the old behaviour. */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) { return; }

  /* How close to the viewport a clip must be before it may load.
     0.75 = three quarters of a screen below the fold. Raise it if clips
     ever appear to pop in late on fast scrolling. */
  var NEAR_SCREENS = 0.75;
  var PRELOAD_WHEN_NEAR = 'metadata';

  function park(video) {
    if (video.dataset.odymParked) { return; }

    /* Remember what the theme asked for so we can restore it exactly. */
    video.dataset.odymPreload = video.getAttribute('preload') || 'metadata';
    video.dataset.odymAutoplay = video.autoplay ? '1' : '0';

    video.setAttribute('preload', 'none');
    video.autoplay = false;

    /* Detach sources so the browser issues no request at all. */
    var sources = video.querySelectorAll('source[src]');
    Array.prototype.forEach.call(sources, function (s) {
      s.dataset.odymSrc = s.getAttribute('src');
      s.removeAttribute('src');
    });
    if (video.getAttribute('src')) {
      video.dataset.odymSrcAttr = video.getAttribute('src');
      video.removeAttribute('src');
    }

    video.dataset.odymParked = '1';
  }

  function wake(video) {
    if (video.dataset.odymParked !== '1') { return; }
    video.dataset.odymParked = '2';

    var sources = video.querySelectorAll('source[data-odym-src]');
    Array.prototype.forEach.call(sources, function (s) {
      s.setAttribute('src', s.dataset.odymSrc);
    });
    if (video.dataset.odymSrcAttr) {
      video.setAttribute('src', video.dataset.odymSrcAttr);
    }

    video.setAttribute('preload', PRELOAD_WHEN_NEAR);
    video.load();

    if (video.dataset.odymAutoplay === '1') {
      video.autoplay = true;
      video.muted = true;
      video.setAttribute('playsinline', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        wake(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: Math.round(NEAR_SCREENS * 100) + '% 0px' });

  function scan() {
    var videos = document.querySelectorAll('video:not([data-odym-parked])');
    Array.prototype.forEach.call(videos, function (v) {
      var box = v.getBoundingClientRect();

      /* Never park something the visitor can already see - that would put a
         black rectangle where a frame should be. Everything below the fold
         waits its turn. */
      if (box.bottom > 0 && box.top < window.innerHeight) {
        v.dataset.odymParked = '2';
        return;
      }
      park(v);
      observer.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Sections injected later (customizer, app blocks, quick view). */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
}());
